import * as e from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/CaretUp.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: m }));
o.displayName = "CaretUpIcon";
const s = o;
export {
  s as CaretUp,
  o as CaretUpIcon
};
